module.exports = __webpack_public_path__ + "static/img/6.dddc554.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/6.png
// module id = bvch
// module chunks = 1